<div class="admin-layout">
  <div class="sidebar" [class.collapsed]="isSidebarCollapsed">
    <div class="sidebar-header">
      <div class="sidebar-header-top">
        <h1>WHATSAPP BUSINESS</h1>
        <button class="toggle-btn" type="button" aria-label="Alternar menu" (click)="toggleSidebar()">
          <i class="bi bi-list"></i>
        </button>
      </div>
      <p>Gestión de contenidos</p>
    </div>

    <nav class="sidebar-nav">
      @for (item of menuItems; track item.route) {
      <div class="nav-item" animate.enter="loaded-height-enter">
        <a [routerLink]="[item.route]" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" class="nav-link">
          <i [class]="item.iconClass + ' menu-icon'"></i>
          <span class="menu-label">{{ item.label }}</span>
        </a>
      </div>
      }
    </nav>
  </div>

  <div class="main-wrapper" [class.sidebar-collapsed]="isSidebarCollapsed">
    <div class="header">
      <div class="header-left">
        <button class="toggle-btn" type="button" (click)="toggleSidebar()">
          <i class="bi bi-list"></i>
        </button>
        <h2>{{ pageTitle }}</h2>
      </div>
      <div class="header-actions">
        <button class="icon-btn" type="button" title="Cerrar sesion" (click)="logout()">
          <i class="bi bi-box-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
